import {
  mdiCarWrench,
  mdiPropaneTank,
  mdiWrenchClock,
  mdiFileCertificateOutline,
  mdiCarSearch,
  mdiCogOutline,
  mdiOilLevel,
  mdiTruckTrailer,
} from "@mdi/js";

// Hizmet verileri. Her hizmetin detay sayfası /hizmetler/:slug altında otomatik oluşur.
export const services = [
  {
    slug: "lpg-montaj",
    title: "LPG Montaj",
    short: "Aracınıza uygun sıralı sistem LPG dönüşümü, 3 aşama 22 nokta kalite kontrolü ile.",
    icon: mdiCarWrench,
    image: "/images/services/lpg-montaj.jpg",
    featured: true,
    seoTitle: "LPG Montaj Yalova Altınova | Sıralı Sistem LPG Dönüşümü",
    seoDescription:
      "Yalova Altınova Kaytazdere'de Sıralı sistem LPG montajı. 30 yıllık tecrübe, Atiker ve Zavoli sıralı sistemler, 2 yıl garanti. Hemen teklif alın.",
    intro:
      "Benzinli aracınızı performans kaybı yaşamadan, %40'a varan yakıt tasarrufu sağlayan LPG'ye dönüştürüyoruz. Araç tipinize uygun sıralı sistemi birlikte seçiyor, montajı 3 aşama 22 nokta kalite kontrolü ile teslim ediyoruz.",
    bullets: [
      "ECE R67.01 standartlarına uygun ekipman",
      "Atiker, Zavoli ve diğer güvenilir markalar",
      "Araç tipine özel sistem ve tank seçimi",
      "Montaj sonrası kalibrasyon ve yol testi",
      "2 yıl garanti ve ücretsiz ilk kontrol",
      "TÜVTÜRK için LPG projesi ve sızdırmazlık raporu",
    ],
    steps: [
      { title: "Araç analizi", text: "Motor tipi, bagaj yapısı ve kullanım alışkanlığınıza göre en uygun sistem belirlenir." },
      { title: "Montaj", text: "Sıralı sistem kiti ve tank, orijinal yakıt sistemine zarar vermeden monte edilir." },
      { title: "Kalibrasyon", text: "Sistem aracın ECU verileriyle ayarlanır, yakıt tüketimi ve performans optimize edilir." },
      { title: "Belgelendirme", text: "Sızdırmazlık raporu ve proje belgeleri hazırlanır, muayeneye hazır teslim edilir." },
    ],
    faq: [
      { q: "LPG montajı ne kadar sürer?", a: "Araç modeline göre değişmekle birlikte montaj genellikle aynı gün içinde, ortalama 4-6 saatte tamamlanır." },
      { q: "LPG performans kaybı yapar mı?", a: "Doğru seçilmiş ve doğru kalibre edilmiş sıralı sistemlerde hissedilir bir performans kaybı olmaz. Motor gücünün büyük bölümü korunur." },
      { q: "Montaj maliyeti ne kadar sürede geri döner?", a: "Aylık kilometrenize bağlı olarak dönüşüm maliyeti çoğu araçta 6-12 ay içinde yakıt tasarrufuyla kendini amorti eder. Tasarruf hesaplayıcımızla kendi aracınız için hesaplayabilirsiniz." },
    ],
  },
  {
    slug: "lpg-tank-degisimi",
    title: "LPG Tank Değişimi",
    short: "10 yılı dolan tankların yasal değişimi, silindir ve simit tank seçenekleri.",
    icon: mdiPropaneTank,
    image: "/images/services/lpg-tank.jpg",
    featured: true,
    seoTitle: "LPG Tank Değişimi Yalova | 10 Yıllık Tank Yenileme",
    seoDescription:
      "LPG tankınızın 10 yıllık ömrü doldu mu? Yalova Altınova'da yasal LPG tank değişimi, silindir ve simit tank seçenekleri, sızdırmazlık raporu ile teslim.",
    intro:
      "LPG tankları üretim tarihinden itibaren 10 yıl kullanılabilir; süresi dolan tankın değiştirilmesi hem yasal zorunluluk hem de güvenliğiniz için şarttır. Bagaj hacminize ve aracınıza uygun tank seçenekleriyle değişimi aynı gün yapıyoruz.",
    bullets: [
      "Silindir ve simit (stepne yuvası) tank seçenekleri",
      "ECE R67 homologasyonlu yeni tanklar",
      "Multivalf kontrolü ve gerekiyorsa yenileme",
      "Değişim sonrası sızdırmazlık testi ve raporu",
      "Eski tankın güvenli şekilde bertarafı",
    ],
    steps: [
      { title: "Tank boşaltma", text: "Mevcut tanktaki gaz güvenli şekilde tahliye edilir." },
      { title: "Söküm", text: "Multivalf ve bağlantı elemanları sökülür, eski tank çıkarılır." },
      { title: "Yeni tank montajı", text: "Yeni tank ve bağlantılar standartlara uygun şekilde monte edilir." },
      { title: "Test ve rapor", text: "Sızdırmazlık testi yapılır, muayene için rapor hazırlanır." },
    ],
    faq: [
      { q: "Tankımın kaç yıllık olduğunu nasıl öğrenirim?", a: "Tankın üzerindeki etikette üretim tarihi yazar. Emin değilseniz servisimize uğrayın, ücretsiz kontrol edelim." },
      { q: "Tank değişimi ne kadar sürer?", a: "Çoğu araçta 2-3 saat içinde tamamlanır." },
      { q: "Tank değişmeden muayeneden geçer miyim?", a: "Hayır. 10 yılı dolmuş tankla TÜVTÜRK muayenesinden geçemezsiniz ve sızdırmazlık raporu alamazsınız." },
    ],
  },
  {
    slug: "lpg-bakim",
    title: "LPG Bakım ve Arıza",
    short: "Filtre değişimi, ayar, kaçak testi ve LPG sistemi arıza tespiti.",
    icon: mdiWrenchClock,
    image: "/images/services/lpg-bakim.jpg",
    featured: true,
    seoTitle: "LPG Bakım ve Arıza Servisi Yalova Altınova",
    seoDescription:
      "LPG filtre değişimi, gaz ayarı, enjektör temizliği ve arıza tespiti. Yalova Altınova Kaytazdere'de 30 yıllık tecrübeyle LPG bakım servisi.",
    intro:
      "LPG sisteminin düzenli bakımı yakıt tüketimini düşürür, motoru korur ve güvenliğinizi sağlar. Her 10.000 km'de filtre değişimi ve genel kontrol öneriyoruz. Gaza geçmeme, tekleme, yüksek tüketim gibi arızaların tespitini de yapıyoruz.",
    bullets: [
      "Gaz fazı ve sıvı faz filtre değişimi",
      "Enjektör temizliği ve kalibrasyon",
      "Regülatör ve multivalf kontrolü",
      "Kaçak (sızdırmazlık) testi",
      "Arıza tespiti ve onarım",
      "Atiker ve Zavoli orijinal yedek parça",
    ],
    steps: [
      { title: "Kontrol", text: "Sistem cihaz ile okunur, tüketim ve arıza kayıtları incelenir." },
      { title: "Bakım", text: "Filtreler değiştirilir, enjektör ve regülatör kontrol edilir." },
      { title: "Ayar", text: "Gaz haritası yeniden ayarlanır, performans test edilir." },
    ],
    faq: [
      { q: "LPG bakımı ne sıklıkla yapılmalı?", a: "Filtre değişimi için her 10.000 km, genel kontrol için yılda bir kez öneriyoruz." },
      { q: "Aracım gaza geçmiyor, sebebi ne olabilir?", a: "Tıkalı filtre, arızalı regülatör sıcaklık sensörü veya düşük gaz seviyesi en sık nedenlerdir. Kısa bir kontrolle tespit edebiliriz." },
    ],
  },
  {
    slug: "sizdirmazlik-raporu",
    title: "Sızdırmazlık Raporu",
    short: "TÜVTÜRK muayenesi için LPG sızdırmazlık raporu ve proje belgesi.",
    icon: mdiFileCertificateOutline,
    image: "/images/services/tank-bagaj.jpg",
    seoTitle: "LPG Sızdırmazlık Raporu Yalova | TÜVTÜRK Muayene Belgesi",
    seoDescription:
      "TÜVTÜRK araç muayenesi için gerekli LPG sızdırmazlık raporunu Yalova Altınova'da aynı gün hazırlıyoruz. LPG projesi ve montaj belgesi.",
    intro:
      "LPG'li araçların muayeneye girmeden önce geçerli bir sızdırmazlık raporuna ihtiyacı vardır. Sistemi baştan sona kontrol ediyor, gerekli düzeltmeleri yapıyor ve raporu aynı gün hazırlıyoruz.",
    bullets: [
      "TÜVTÜRK şartlarına uygun sızdırmazlık raporu",
      "LPG montaj projesi ve mühendislik belgesi",
      "Muayene öncesi ücretsiz ön kontrol",
      "Aynı gün teslim",
    ],
    steps: [
      { title: "Sistem kontrolü", text: "Tank, hatlar, regülatör ve bağlantılar kontrol edilir." },
      { title: "Test", text: "Basınç ve kaçak testi uygulanır." },
      { title: "Rapor", text: "Rapor ve gerekli belgeler hazırlanıp size teslim edilir." },
    ],
    faq: [
      { q: "Sızdırmazlık raporu ne kadar geçerli?", a: "Rapor bir yıl geçerlidir; her muayene öncesi yenilenmesi gerekir." },
    ],
  },
  {
    slug: "genel-kontrol",
    title: "Genel Kontrol",
    short: "Uzun yol öncesi motor, LPG sistemi ve güvenlik kontrolü.",
    icon: mdiCarSearch,
    image: "/images/services/genel-kontrol.jpg",
    seoTitle: "Araç Genel Kontrol ve Uzun Yol Bakımı Yalova",
    seoDescription:
      "Uzun yola çıkmadan önce aracınızı 30 yıllık tecrübeli ustamıza kontrol ettirin. Motor, LPG sistemi, sıvılar ve güvenlik kontrolü.",
    intro:
      "Yola çıkmadan önce aracınızın genel durumunu kontrol ediyoruz: motor sıvıları, LPG sistemi, akü, kayış ve hortumlar, lastik basıncı. Küçük bir kontrol, yolda büyük bir sorunun önüne geçer.",
    bullets: [
      "Motor yağı, soğutma sıvısı ve fren hidroliği seviyeleri",
      "LPG sistemi ve kaçak kontrolü",
      "Akü ve şarj sistemi testi",
      "Kayış, hortum ve bağlantı kontrolü",
      "Lastik ve fren görsel kontrolü",
    ],
    steps: [
      { title: "Kontrol listesi", text: "Aracınız standart kontrol listesine göre incelenir." },
      { title: "Rapor", text: "Tespit edilen eksikler size anlatılır, öncelik sırasına konur." },
    ],
    faq: [],
  },
  {
    slug: "lpg-yedek-parca",
    title: "LPG Yedek Parça",
    short: "Atiker ve Zavoli orijinal LPG yedek parçaları ve filtreler.",
    icon: mdiCogOutline,
    image: "/images/services/tank-bagaj.jpg",
    seoTitle: "LPG Yedek Parça Yalova | Atiker Zavoli Filtre, Regülatör, Enjektör",
    seoDescription:
      "Atiker ve Zavoli orijinal LPG yedek parçaları: filtre, regülatör, enjektör, multivalf, beyin. Yalova Altınova'da stoktan temin ve montaj.",
    intro:
      "LPG sisteminiz için ihtiyaç duyduğunuz orijinal yedek parçaları stoktan sağlıyor ve isterseniz yerinde monte ediyoruz.",
    bullets: [
      "Gaz ve sıvı faz filtreleri",
      "Regülatör ve regülatör tamir takımları",
      "Enjektör ve enjektör tamir takımları",
      "Multivalf, gaz seviye göstergesi, anahtar",
      "LPG beyni ve kablo setleri",
    ],
    steps: [],
    faq: [],
  },
  {
    slug: "yag-degisimi",
    title: "Motor Yağı Değişimi",
    short: "Aracınıza uygun yağ ve filtre ile periyodik motor yağı değişimi.",
    icon: mdiOilLevel,
    image: "/images/blog/mekanik-lift.jpg",
    featured: true,
    isNew: false,
    seoTitle: "Motor Yağı Değişimi Yalova Altınova | Yağ ve Filtre Bakımı",
    seoDescription:
      "Yalova Altınova Kaytazdere'de motor yağı ve filtre değişimi. Aracınıza uygun viskozitede kaliteli yağ, yağ filtresi, hava ve polen filtresi değişimi.",
    intro:
      "Motor yağı değişimi, aracınızın ömrünü en çok etkileyen periyodik bakımdır. Aracınızın üretici tavsiyesine uygun viskozite ve kalitedeki yağı, orijinal veya muadil filtrelerle birlikte değiştiriyoruz. LPG'li araçlarda yağ değişim aralığının neden daha önemli olduğunu da anlatıyoruz.",
    bullets: [
      "Üretici onaylı viskozitede tam sentetik ve yarı sentetik yağlar",
      "Yağ filtresi değişimi",
      "İsteğe bağlı hava ve polen filtresi değişimi",
      "Seviye ve kaçak kontrolü",
      "Bakım kaydı ve bir sonraki değişim hatırlatması",
    ],
    steps: [
      { title: "Yağ seçimi", text: "Aracın kataloğuna göre doğru viskozite ve norm belirlenir." },
      { title: "Değişim", text: "Eski yağ boşaltılır, filtre değiştirilir, yeni yağ doldurulur." },
      { title: "Kontrol", text: "Seviye ve kaçak kontrolü yapılır, bakım etiketi yapıştırılır." },
    ],
    faq: [
      { q: "Motor yağı ne zaman değiştirilmeli?", a: "Genel olarak 10.000-15.000 km veya yılda bir kez. LPG'li araçlarda ve şehir içi kısa mesafe kullanımında daha erken değişim öneriyoruz." },
      { q: "Kendi yağımı getirebilir miyim?", a: "Evet, getirebilirsiniz. Ancak aracınıza uygunluğunu birlikte kontrol edelim." },
    ],
  },
  {
    slug: "ceki-demiri",
    title: "Çeki Demiri Montajı",
    short: "Römork ve karavan için onaylı çeki demiri montajı ve elektrik tesisatı.",
    icon: mdiTruckTrailer,
    image: "/images/blog/arac.jpg",
    featured: true,
    isNew: false ,
    seoTitle: "Çeki Demiri Montajı Yalova | Römork ve Karavan Çeki Demiri",
    seoDescription:
      "Yalova Altınova'da aracınıza uygun onaylı çeki demiri montajı, 7 ve 13 pin elektrik tesisatı. Römork, karavan ve bisiklet taşıyıcı için.",
    intro:
      "Römork, karavan, tekne taşıyıcı veya bisiklet taşıyıcı için aracınıza uygun çeki demirini monte ediyoruz. Araç modelinize özel, homologasyonlu çeki demiri ve elektrik tesisatı ile işlem tamamlanır.",
    bullets: [
      "Araca özel, ECE onaylı çeki demiri",
      "Sabit ve sökülebilir (çıkarılabilir) modeller",
      "7 pin ve 13 pin elektrik tesisatı",
      "Park sensörü ile uyumlu modül montajı",
      "Ruhsat işlemi için gerekli belgeler",
    ],
    steps: [
      { title: "Model seçimi", text: "Aracınıza uygun sabit veya sökülebilir çeki demiri seçilir." },
      { title: "Montaj", text: "Şasiye üretici noktalarından bağlantı yapılır." },
      { title: "Elektrik", text: "Römork priz tesisatı çekilir, sinyal ve stop lambaları test edilir." },
    ],
    faq: [
      { q: "Çeki demiri ruhsata işlenmeli mi?", a: "Evet. Montaj sonrası çeki demiri araç ruhsatına işletilmelidir. Gerekli belgeleri hazırlıyoruz." },
      { q: "Montaj ne kadar sürer?", a: "Araca göre değişmekle birlikte genellikle 2-4 saat içinde tamamlanır." },
    ],
  },
];

export const getService = (slug) => services.find((s) => s.slug === slug);
export const featuredServices = services.filter((s) => s.featured);
